import { ArsTableGroupCalculationDto } from "../interface";

/**
 * Checks whether the given table groups contain an analysis method or operation.
 *
 * @param tableGroups - Array of table groups to check
 * @returns True if any table group contains an analysis method or operation, false otherwise
 */
export const containsAnalysisMethod = <T>(
  tableGroups?: ArsTableGroupCalculationDto<T>[],
): boolean => {
  return (
    tableGroups?.some((tableGroup) => {
      if ("analysisMethod" in tableGroup || "operation" in tableGroup) return true;
      else return containsAnalysisMethod(tableGroup.subGroups);
    }) ?? false
  );
};
